<template>
  <div style="background-color: #eeeeee; padding-bottom: 100px">
    <img style="display: block; margin: 0 auto" src="../../assets/banner6.png" alt="" />
    <div class="main">
      <ul class="Breadcrumb">
        <li @click="backPage('/home')">{{ $t("home") }}</li>
        <!-- <li>></li>
        <li>服务支持</li> -->
        <li>></li>
        <li>{{ $t("tecArticles") }}</li>
      </ul>
      <div class="content">
        <div class="menu">
          <Menu :active="'1'" />
        </div>
        <div class="apply">
          <div v-for="(item, index) in list" :key="index">
            <div class="fleft">
              <h3 @click="goPath(item)">{{ item.title }}</h3>
              <i>{{ item.createTime }}</i>
              <p>{{ item.description }}</p>
            </div>
            <div class="fright">
              <img :src="item.coverImage" alt="" />
            </div>
          </div>
        </div>
      </div>
      <pagination
        style="margin-top: 10px"
        :num="total"
        :limit="pageSize"
        @getNew="getList"
      ></pagination>
    </div>
  </div>
</template>
<script>
import Menu from "./menu/index.vue";
import { backPage } from "@/utils/common";
import { getNewsList } from "../../api/index";
import pagination from "../../components/page/pagination.vue";
export default {
  components: {
    Menu,
    pagination,
  },
  data() {
    return {
      list: [],
      total: 0,
      pageSize: 10,
      languageCode:"zh"
    };
  },
  methods: {
    getList(val) {
      let params = {
        pageNum: val + 1,
        pageSize: this.pageSize,
        category: 3,
        publishStatus: 1,
        languageCode:this.languageCode == "zh" ? "zh-CN" : "en-US"
      };
      getNewsList(params).then((res) => {
        this.list = res.rows;
        this.total = res.total;
      });
    },
    getLocalizedPath(rawPath) {
      const currentLang = this.$i18nState.locale || "zh";
      // 如果路径已经以 /zh 或 /en 结尾，则直接返回
      if (/\/(zh|en)$/.test(rawPath)) {
        return rawPath;
      }
      // 移除路径末尾多余的斜杠，然后添加语言
      const base = rawPath.endsWith("/") ? rawPath.slice(0, -1) : rawPath;
      return `${base}/${currentLang}`;
    },
    goPath(item) {
      console.log(item);
      const fullPath = this.getLocalizedPath("/newsDetail");
      this.$router.replace({ path: fullPath, query: { id: item.id } });
      document.documentElement.scrollTop = 0;
    },
    backPage,
  },
  mounted() {
    const lang = this.$i18nState.locale; // ✅ 正确的语言获取方式
    this.languageCode = lang
    this.getList(0);
  },
};
</script>
<style lang="scss" scoped>
.content {
  display: flex;

  .menu {
    width: 250px;
  }

  .apply {
    flex: 1;
    margin-left: 30px;

    > div {
      background-color: #fff;
      padding: 20px 20px 20px 30px;
      margin-bottom: 30px;
      overflow: hidden;
    }
    .fright {
      width: 200px;
      img {
        height: 140px;
        width: 100%;
      }
    }
    .fleft {
      padding-top: 40px;
      width: 600px;
    }
    h3 {
      font-size: 22px;
      color: #222222;
      cursor: pointer;
    }
    h3:hover {
      color: #226cbf;
    }

    i {
      font-style: normal;
      padding-left: 20px;
      background: url("../../assets/icon10.png") no-repeat center left;
      font-size: 14px;
      color: #717171;
      line-height: 60px;
    }

    p {
      overflow: hidden; //超出文本隐藏
      text-overflow: ellipsis; ///超出部分省略号显示
      display: -webkit-box; //弹性盒模型
      -webkit-box-orient: vertical; //上下垂直
      -webkit-line-clamp: 2;
      font-size: 16px;
      line-height: 34px;
      color: #222222;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/fwzc/tecArticles.vue